import React from 'react'
import { Button } from '@/components/ui/button'
import { UserPlus, Plus } from 'lucide-react'

interface UsersEmptyStateProps {
  onInviteClick: () => void
}

export function UsersEmptyState({ onInviteClick }: UsersEmptyStateProps) {
  return (
    <div className="text-center py-8">
      <UserPlus className="h-12 w-12 text-gray-400 mx-auto mb-4" />
      <h3 className="text-lg font-medium text-gray-900 mb-2">No users found</h3>
      <p className="text-gray-500 mb-4">Get started by inviting your first user.</p>
      <Button onClick={onInviteClick} aria-label="Invite your first user">
        <Plus className="h-4 w-4 mr-2" />
        Invite User
      </Button>
    </div>
  )
}
